import { GET_POLLEN_BY_LATLON } from '../actions/pollenActions';
import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    pollenIsRefreshing: false
};

export function pollen(state = initialState, action)
{
    switch (action.type)
    {
        case LOCATION_CHANGED:
        {
            return initialState;
        }
        case GET_POLLEN_BY_LATLON.pending:
        {
            return {
                ...state
                , pollenIsRefreshing: true
            };
        }

        case GET_POLLEN_BY_LATLON.fulfilled:
        {
            return {
                ...state
                , pollen: action.payload
                , lastError: {}
                , pollenIsRefreshing: false
            };
        }

        case GET_POLLEN_BY_LATLON.rejected:
        {
            return {
                ...state
                , pollen: undefined
                , lastError: action.payload
                , pollenIsRefreshing: false
            };
        }

        default:
        {
            return state;
        }
    }
}
